<script>
    import Image from './Image.svelte';
</script>

<div class="section">
    <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
            <div class="card my-2 mx-0">
                <Image src="/img/wide0.jpg" class="card-img-top" alt="image" style="height: 300px;object-fit: cover;object-position: center center;" />
                <div class="card-body placeholder-glow">
                    <h5 class="card-title">
                        <span class="placeholder col-7"></span>
                    </h5>
                    <p class="card-text">
                        <span class="placeholder col-10"></span>
                        <span class="placeholder col-4"></span>
                    </p>
                </div>
            </div>
        </div>
        
        <div class="col-12 col-md-6 col-lg-4">
            <div class="card my-2 mx-0">
                <Image src="/img/wide0.jpg" class="card-img-top" alt="image" style="height: 300px;object-fit: cover;object-position: center center;" />
                <div class="card-body placeholder-glow">
                    <h5 class="card-title">
                        <span class="placeholder col-5"></span>
                    </h5>
                    <p class="card-text">
                        <span class="placeholder col-8"></span>
                    </p>
                </div>
            </div>
        </div>
        
        <div class="col-12 col-md-6 col-lg-4">
            <div class="card my-2 mx-0">
                <Image src="/img/wide0.jpg" class="card-img-top" alt="image" style="height: 300px;object-fit: cover;object-position: center center;" />
                <div class="card-body placeholder-glow">
                    <h5 class="card-title">
                        <span class="placeholder col-8"></span>
                    </h5>
                    <p class="card-text">
                        <span class="placeholder col-6"></span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
